import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import MarketingShell from "@/components/MarketingShell";
import { PHOTOS } from "@/lib/photos";

export default function Galas() {
  return (
    <MarketingShell active="/events/galas">
      <motion.section initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="text-[10px] uppercase tracking-[0.32em] mb-3" style={{ color: "#F2D589" }}>
          Private events &middot; Galas &amp; events
        </p>
        <h1
          className="leading-[0.95]"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 500,
            fontSize: "clamp(40px, 5.6vw, 84px)",
            textWrap: "balance",
            maxWidth: "22ch",
          }}
        >
          Music that supports the room, <em style={{ color: "#F2D589" }}>never overshadows it</em>.
        </h1>
      </motion.section>

      <section className="mt-12 grid md:grid-cols-[1fr_1.2fr] gap-10 items-start">
        <div
          className="rounded-2xl overflow-hidden border"
          style={{ borderColor: "rgba(255,255,255,0.12)", aspectRatio: "4 / 5" }}
        >
          <img src={PHOTOS.warmRoom} alt="Concert hall ambiance" className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="space-y-4 text-base sm:text-lg leading-relaxed" style={{ color: "rgba(245,239,227,0.82)" }}>
          <p>
            Solo piano, or a curated ensemble of world-class collaborators, built around creating a sound that supports your event
            instead of stealing focus from it.
          </p>
          <p>
            Rooted in jazz and Jewish musical influence, the music is warm,
            expressive, and never distracting. It&apos;s not dance music, it&apos;s music that creates ambiance, uplifts the
            space, and leaves a lasting impression.
          </p>
          <p>
            Whether you&apos;re hosting donors, celebrating a milestone, or
            curating an evening of culture, this offering brings artistry
            and sophistication to the room.
          </p>
          <p style={{ color: "#F2D589" }}>
            <strong>Perfect for</strong> fundraisers, galas, gallery nights,
            wine &amp; cheese receptions, speaker series, and upscale
            simchas.
          </p>
        </div>
      </section>

      <section className="mt-12 flex flex-wrap gap-3">
        <Link
          to="/contact"
          data-testid="galas-book-cta"
          className="inline-flex items-center justify-center rounded-full px-6 h-12 text-sm uppercase tracking-[0.22em]"
          style={{ backgroundColor: "transparent", color: "#F2D589", border: "1px solid #F2D589", fontWeight: 600 }}
        >
          Book elegant event music &rsaquo;
        </Link>
        <Link
          to="/community-events"
          className="inline-flex items-center justify-center rounded-full px-6 h-12 text-sm uppercase tracking-[0.22em] border border-white/25 hover:bg-white/10 transition-colors"
        >
          &lsaquo; All community events
        </Link>
      </section>
    </MarketingShell>
  );
}
